import React, { useState } from 'react'
import { Mic, Ear, LogOut, Monitor, Globe } from 'lucide-react'

interface ModeSelectorProps {
  onSelectMode: (mode: 'presenter' | 'audience', options?: { captureType?: 'microphone' | 'browser'; sourceLang?: string; targetLang?: string }) => void
  onLogout: () => void
}

const ModeSelector: React.FC<ModeSelectorProps> = ({ onSelectMode, onLogout }) => {
  const [sourceLang, setSourceLang] = useState('vi')
  const [targetLang, setTargetLang] = useState('en')

  const languages = [
    { code: 'vi', name: 'Vietnamese' },
    { code: 'en', name: 'English' },
  ]

  return (
    <div className="mode-selector">
      <div className="mode-header">
        <h1>NIM Speech Translator</h1>
        <p className="subtitle">Real-time Speech Translation</p>
      </div>

      {/* Language Pair Selector */}
      <div className="language-selector">
        <div className="lang-select">
          <label><Globe size={16} /> From:</label>
          <select value={sourceLang} onChange={(e) => setSourceLang(e.target.value)}>
            {languages.map(lang => (
              <option key={lang.code} value={lang.code}>{lang.name}</option>
            ))}
          </select>
        </div>
        <span className="arrow">→</span>
        <div className="lang-select">
          <label><Globe size={16} /> To:</label>
          <select value={targetLang} onChange={(e) => setTargetLang(e.target.value)}>
            {languages.map(lang => (
              <option key={lang.code} value={lang.code}>{lang.name}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="mode-buttons">
        <button
          className="mode-btn presenter-btn"
          onClick={() => onSelectMode('presenter', { captureType: 'microphone', sourceLang, targetLang })}
        >
          <Mic size={48} />
          <span>I am Speaking</span>
          <p className="mode-desc">Use microphone to speak {sourceLang === 'vi' ? 'Vietnamese' : 'English'}</p>
        </button>

        <button
          className="mode-btn presenter-btn"
          onClick={() => onSelectMode('presenter', { captureType: 'browser', sourceLang, targetLang })}
        >
          <Monitor size={48} />
          <span>Translate Browser Audio</span>
          <p className="mode-desc">Capture audio from YouTube, videos, etc.</p>
        </button>

        <button
          className="mode-btn audience-btn"
          onClick={() => onSelectMode('audience', { sourceLang, targetLang })}
        >
          <Ear size={48} />
          <span>I am Listening</span>
          <p className="mode-desc">Listen to translated {targetLang === 'vi' ? 'Vietnamese' : 'English'}</p>
        </button>
      </div>

      <button className="logout-btn" onClick={onLogout}>
        <LogOut size={20} />
        <span>Logout</span>
      </button>
    </div>
  )
}

export default ModeSelector
